import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from './pages/Login/Login';
import Main from "./layout/Main";
import Signup from "./pages/Signup/Signup";
import Home from "./pages/Home/Home";
import Trips from "./pages/Trips/Trips";
import ZonesActivity from "./pages/Zones/ZonesActivity";
import Reports from "./pages/Reports/Reports";
import Accounts from "./pages/Accounts/Accounts";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import UserManagement from "./pages/UserManagement/UserManagement";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import VerifyEmail from "./pages/VerifyEmail/VerifyEmail";
import SubscriptionManagement from "./pages/SubscriptionPlanManagement/SubscriptionManagement";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import ReportPdf from "./components/ReportPdf/ReportPdf";
import UpgradePlan from "./pages/UpgradePlan/UpgradePlan";
import HealthDashboard from "./pages/HealthDashboard/HealthDashboard";
import TimeTracking from "./pages/TimeTracking/TimeTracking";

function App() {

  return (
    <BrowserRouter basename="">
      <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      
      <Route element={<ProtectedRoute />}>
        <Route path="/main" element={<Main />} >
          <Route path="/main/home" element={<Home />} />
          <Route path="/main/time-tracking" element={<TimeTracking />} />
          <Route path="/main/trips" element={<Trips />} />
          <Route path="/main/zones" element={<ZonesActivity />} />
          <Route path="/main/reports" element={<Reports />} />
          <Route path="/main/account" element={<Accounts />} />
          <Route path="/main/upgrade-plan" element={<UpgradePlan />} />
          <Route path="/main/user" element={<UserManagement />} />
          <Route path="/main/subscription" element={<SubscriptionManagement/>} />
          <Route path="/main/health" element={<HealthDashboard />} />
          <Route path="/main/report-pdf" element={<ReportPdf />} />
        </Route>
      </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
